import { useState } from 'react';

export default function FAQAccordion({ items = [], title = 'Ofte stillede spørgsmål' }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!items || items.length === 0) return null;

  return (
    <div className="w-full my-12">
      <div className="mb-6">
        <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest block mb-1">
          Teknisk information
        </span>
        <h3 className="font-display text-2xl font-bold text-white tracking-tight">
          {title}
        </h3>
      </div>

      <div className="space-y-3">
        {items.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={item.id || item.question}
              className={`rounded-xl border transition-all ${
                isOpen
                  ? 'bg-[#0e1622] border-cyan-500/40 shadow-lg shadow-cyan-950/20'
                  : 'bg-[#090e15] border-slate-800 hover:border-slate-700'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                className="w-full px-5 py-4 flex items-center justify-between text-left gap-4 focus:outline-none"
                aria-expanded={isOpen}
              >
                <span className="font-display font-semibold text-base text-white">
                  {item.question}
                </span>
                <span className={`p-1.5 rounded-md text-xs transition-transform duration-200 shrink-0 ${
                  isOpen ? 'rotate-180 text-cyan-400 bg-cyan-950/50' : 'text-slate-400 bg-slate-800'
                }`}>
                  <i className="fa-solid fa-chevron-down" aria-hidden="true" />
                </span>
              </button>

              {isOpen && (
                <div className="px-5 pb-5 pt-1 text-sm text-slate-300 leading-relaxed border-t border-slate-800/80 prose prose-invert max-w-none">
                  {typeof item.answer === 'string' ? (
                    <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                  ) : (
                    item.answer
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
